import { Link } from 'react-router-dom';
import BackCircle from '@/images/icons/BackCircle';
import BackChevron from '@/images/icons/BackChevron';
import React from 'react';

export default function BackButtonPage({ to, title, backgroundColor }: { to: string, title: string, backgroundColor?: string }) {
	return (
		<div className="md:absolute -mt-4 md:mt-0 mb-4 md:mb-0 top-1 -left-[52px] flex items-center justify-start">
			<Link to={to}
			      className="inline-flex md:flex items-center gap-1 md:gap-0 text-[11px]/[1.1]">
				<BackCircle className="w-8 h-8 hidden md:block" backgroundColor={backgroundColor ? backgroundColor : '#F7F6F2'} />
				<BackChevron className="w-5 h-5 md:hidden" />
				<span className="md:hidden">{title}</span>
			</Link>
		</div>
	);
}
